import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import { InputLabel, Paper, Tooltip } from "@mui/material";
import ManageSearchRoundedIcon from '@mui/icons-material/ManageSearchRounded';
import DraggableDialog from "../CustomDialogs/DraggableDialog";
import ARlist from "./Components/ARlist";
import { defaultFont } from "../../assets/jss/psstyle/psacount";
import { set } from "date-fns";

const styles = {
    textField: {
        fontFamily: "Customfont !important"
    }
}
export default function CustomARInput(props) {
    const { label, id, defaultValue, helperText, inputType, tabIndex, placeholder, name } = props


    const [state, setState] = React.useState({
        sendData: false,
        inputData: null,
        openDialog: false,
        titleDialog: "เลือกลูกค้า"
    });
    React.useEffect(() => {
        setState({ ...state, inputData: defaultValue, sendData: false })
        return () => {
        }
    }, [defaultValue])

    useEffect(() => {
        try {
            if (state.sendData === true) {
                props.resData(typeof state.inputData !== "undefined" ? state.inputData : null)
                setState({ ...state, sendData: false })
            }
        } catch (error) {
            console.log("onBlur error", error);
        }
    }, [state.sendData])
    const handleChange = (event) => {
        // event.preventDefault(); 
        console.log("handleChange", event.target.value);
        setState({
            ...state,
            inputData: event.target.value,
            sendData: true
        })
        // try {
        //  props.resData(event.target.value === "" ? null : event.target.value)
        // } catch (error) {
        // }
    }
    const onBlur = (event) => {
        //   console.log("onBlur", event.target.value);
        try {
            // setInputData(event.target.value)
            //   setState({ ...state, sendData: true,inputData: event.target.value === "" ? null : event.target.value })
            //   setInputData(event.target.value === "" ? null : event.target.value);
            setState({ ...state, sendData: true })
            props.onBlur()
        } catch (error) {
            console.log("onBlur error", error);
        }
    }

    const handleKeyDown = (event) => {
        // event.preventDefault(); 
        try {
            if (event.key === "Enter") {
                setState({ ...state, sendData: true })
            }
            props.keyDown(event.key)

        }
        catch (error) {
            console.log("handleKeyDown err", error);
        }
    }
    const handleSearchClick = () => {
        setState({ ...state, openDialog: true })
    }
    const resultData = async (e) => {
        //   console.log("resultData", e[0].code);
        let code = ""
        for (let index = 0; index < e.length; index++) {
            code += await e[index].code
            code += await index > -1 && index < e.length - 1 ? "," : "";
        }
        await setState({
            ...state,
            sendData: true,
            inputData: code,
            openDialog: false,
        })
        await props.onSelect()
    }
    return (
        <>
            <Paper
                elevation={0}
                component="div"
                sx={{
                    pl: '4px',
                    m: "0px",
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: "#eee",
                    border: "1px solid #ccc",
                    verticalAlign: "middle",
                }}
            >
                <Tooltip title={label}>
                    <InputLabel sx={{
                        width: "140px", whiteSpace: "nowrap",
                        fontSize: "14px",
                        ...defaultFont,
                        fontWeight: "700",
                        verticalAlign: "middle"
                    }}  >{label}</InputLabel>
                </Tooltip>
                <TextField
                    sx={{
                        //     "& label.Mui-focused": {
                        //         display: "none",
                        //     },
                        //     "& legend": {
                        //         display: "none",
                        //     },
                        backgroundColor: "#fff",
                        ...defaultFont
                        //     marginTop: "0px",
                    }}
                    hiddenLabel
                    id={id}
                    name={name}
                    onChange={handleChange}
                    value={state.inputData}
                    helperText={helperText}
                    variant="standard"
                    size="small"
                    type={inputType}
                    fullWidth
                    tabIndex={tabIndex}
                    placeholder={placeholder}
                    onBlur={e => onBlur(e)}
                    onKeyDown={handleKeyDown}
                />
                <ManageSearchRoundedIcon sx={{ cursor: "pointer" }} onClick={_ => handleSearchClick()} />

            </Paper >

            <DraggableDialog
                open={state.openDialog}
                title={state.titleDialog}
                closeDialog={e =>
                    setState({
                        ...state,
                        openDialog: false
                    })} >
                <ARlist resultData={e => resultData(e)} />
            </DraggableDialog >

        </>
    );
}
CustomARInput.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    defaultValue: PropTypes.string,
    helperText: PropTypes.string,
    inputType: PropTypes.oneOf(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "email", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time-local", "url", "file", "week"]),
    placeholder: PropTypes.string,
    tabIndex: PropTypes.string,

}
CustomARInput.defaultProps = {
    label: "รหัสลูกค้า",
    name: "arCode",

}





